import {Heading} from '@primer/react'
import {Text} from '@primer/styled-react'

import type {CopilotChatMode} from '../utils/copilot-chat-types'
import styles from './ChatWithCopilotHeader.module.css'
import CopilotIconAnimation from './CopilotIconAnimation'

export interface ChatWithCopilotHeaderProps {
  mode: CopilotChatMode
}

export function ChatWithCopilotHeader({mode}: ChatWithCopilotHeaderProps) {
  return (
    <>
      <div className={styles.iconContainer}>
        <CopilotIconAnimation />
      </div>
      <Heading as="h1" className={styles.headerTitle}>
        Ask Copilot
      </Heading>
      <Text
        as="p"
        sx={{
          mb: mode === 'immersive' ? 5 : 3,
        }}
        className={styles.descriptionText}
      >
        Select a repository to get started. Ask questions about your codebase to get answers fast and learn your way
        around.
      </Text>
    </>
  )
}

try{ ChatWithCopilotHeader.displayName ||= 'ChatWithCopilotHeader' } catch {}